<template>
  <ClientOnly>
    <VuePlyr v-if="videoId" :options="options">
      <div data-plyr-provider="youtube" :data-plyr-embed-id="videoId" />
    </VuePlyr>
    <VuePlyr v-else-if="file" :options="options">
      <video :data-poster="poster && poster.permalink" playsinline>
        <source size="1080" :src="file.permalink" type="video/mp4" />
      </video>
    </VuePlyr>
  </ClientOnly>
</template>

<script lang="ts" setup>
import type { AssetFragment } from '#gql'
// @ts-ignore
import 'plyr/dist/plyr.css'

defineProps<{
  videoId?: string | undefined
  file?: AssetFragment
  poster?: AssetFragment
}>()

// register the VuePlyr component
const VuePlyr = defineAsyncComponent(() => import('@skjnldsv/vue-plyr')) as any

const options = {
  controls: [
    'play',
    'progress',
    'current-time',
    'mute',
    'volume',
    'settings',
    'fullscreen',
  ],
  muted: true,
  autoplay: true,
  playsinline: true,
  loop: { active: true },
}
</script>

<style>
:root {
  --plyr-video-control-background-hover: #000;
  --plyr-color-main: #000;
}

.plyr__poster {
  background-size: cover;
}
</style>
